export var STORAGE_NAME = 'app';
export var initialState = {
    isLocked: false,
    pincode: undefined,
    messages: [],
    errors: [],
    useStubs: false,
    lastActivity: undefined,
};
export var cache = {
    isLocked: 0,
    pincode: 0,
    useStubs: 0,
};
